import { Shield, Eye, Handshake, FileCheck } from 'lucide-react';

export const TrustSection = () => {
  const values = [
    {
      icon: Shield,
      title: 'Verlässlich',
      description: 'Ihr Ansprechpartner mit Spezialfokus auf Handelsimmobilien',
    },
    {
      icon: Eye,
      title: 'Transparent',
      description: 'Klare Prozesse und offene Kommunikation in jeder Phase',
    },
    {
      icon: Handshake,
      title: 'Partnerschaftlich',
      description: 'Langfristige Begleitung statt schneller Abschlüsse',
    },
    {
      icon: FileCheck,
      title: 'Strukturiert',
      description: 'Professionelle Vorbereitung und Dokumentation',
    },
  ];

  return (
    <section className="py-24 relative overflow-hidden" data-testid="trust-section">
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=compress&cs=tinysrgb&w=1920)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1628]/95 via-[#0F2744]/90 to-[#0A1628]/95\"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block">
            <div className="w-16 h-1 bg-gradient-to-r from-[#D4A853] to-[#F0C870] mb-4 mx-auto"></div>
          </div>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-white"
          >
            Unsere Arbeitsweise
          </h2>
          <p
            className="text-lg max-w-3xl mx-auto text-gray-200 leading-relaxed"
          >
            Wir setzen auf Ehrlichkeit und strukturierte Prozesse. Kein Marketing-Versprechen,
            sondern fokussierte Arbeit für Ihren Erfolg.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => {
            const IconComponent = value.icon;
            return (
              <div
                key={index}
                className="glass-card text-center p-8 hover:scale-105 transition-transform duration-300"
                data-testid={`trust-value-${index}`}
              >
                <div
                  className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg"
                  style={{
                    background: 'linear-gradient(135deg, #D4A853 0%, #F0C870 100%)',
                  }}
                >
                  <IconComponent className="h-10 w-10 text-white" />
                </div>
                <h3
                  className="text-xl font-bold mb-3"
                  style={{ color: 'var(--navy-800)' }}
                >
                  {value.title}
                </h3>
                <p className="text-sm leading-relaxed" style={{ color: 'var(--gray-600)' }}>
                  {value.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
